/**
 * Enum for model capability keys. Kept in a separate file to avoid
 * constants → types/models → constants dependency cycle.
 */
export enum EModelCapabilityKey {
  IMAGE_GENERATION = "imageGeneration",
  VIDEO_GENERATION = "videoGeneration",
  VISION = "vision",
  DOCUMENT_ANALYSIS = "documentAnalysis",
  TOOLS = "tools",
}
